import * as actionTypes from "store/actions/input/flags/flagsActionTypes";

export const update = (flags) => ({
  type: actionTypes.UPDATE_FLAGS,
  payload: flags,
});

export const createJudgment = (judgment) => ({
  type: actionTypes.CREATE_UW_JUDGMENT,
  payload: {
    ...judgment,
    canDelete: true,
    canEdit: true,
  },
});

export const createExposure = (exposure) => ({
  type: actionTypes.CREATE_EXPOSURE_FLAG,
  payload: {
    ...exposure,
    canDelete: true,
    canEdit: true,
  },
});

export const updateJudgment = (id, column, value) => ({
  type: actionTypes.UPDATE_UW_JUDGMENT,
  payload: { id, column, value },
});

export const updateExposureFlag = (id, column, value) => ({
  type: actionTypes.UPDATE_EXPOSURE_FLAG,
  payload: { id, column, value },
});

export const updateStateId = (id) => ({
  type: actionTypes.UPDATE_STATE_ID,
  payload: id,
});

export const deleteJudgment = (id) => ({
  type: actionTypes.DELETE_UW_JUDGMENT,
  payload: id,
});

export const deleteExposure = (id) => ({
  type: actionTypes.DELETE_EXPOSURE,
  payload: id,
});

export const updateIgnoreOverrides = (value) => ({
  type: actionTypes.UPDATE_JUDGMENT_IGNORE_OVERRIDE,
  payload: value,
});
